import { render, staticRenderFns } from "./avaliacaoCard.vue?vue&type=template&id=a54a5938"
import script from "./avaliacaoCard.vue?vue&type=script&lang=js"
export * from "./avaliacaoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports